import React from 'react';
import { protocolsApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

/**
 * E1 — "Compatible Devices" (instruction §11/§12): strictly separate from
 * Shop. This lists what Sheba can integrate/control, regardless of where
 * a device was purchased — pulled live from the real, already-public
 * backend/device_routes.py::GET /mobile/protocols endpoint (the actual
 * provider registry, not a hardcoded list this page would drift from).
 * Directly documents the existing TV/IR/universal-remote provider
 * coverage the architecture audit found (Roku, Chromecast, Fire TV,
 * Samsung, LG, Apple TV, Broadlink, etc.) without rewriting or
 * duplicating any of it.
 */
export default function CompatibleDevices() {
  const { data: protocols, loading, error, reload } = useApiData(() => protocolsApi.list());

  return (
    <div>
      <h1 className="text-2xl font-bold mb-2">Compatible Devices</h1>
      <p className="text-white/50 mb-8 max-w-2xl">
        Devices Sheba can integrate with and control — whether or not you
        bought them from Sheba. This is different from the{' '}
        <a href="/dashboard/shop" className="text-[#00d4ff]">Shop</a>, which is what
        Sheba sells. You're never required to buy from Sheba to use a
        compatible device.
      </p>
      <StateBlock loading={loading} error={error} onRetry={reload} isEmpty={protocols?.length === 0} emptyLabel="No protocol information available.">
        <div className="grid md:grid-cols-2 gap-4">
          {protocols?.map((p) => (
            <div key={p.id} className="glass rounded-xl p-4">
              <p className="font-medium">{p.name}</p>
              {p.supported_device_types?.length > 0 && p.supported_device_types[0] !== '*' && (
                <p className="text-white/40 text-xs mt-1">
                  {p.supported_device_types.join(', ')}
                </p>
              )}
            </div>
          ))}
        </div>
      </StateBlock>
    </div>
  );
}
